import { c as classNames } from '../../shared/bind-f8092ad0.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "divider": "web_ui__Divider__divider",
  "vertical": "web_ui__Divider__vertical",
  "inverse": "web_ui__Divider__inverse",
  "active": "web_ui__Divider__active"
};

var Orientation = /*#__PURE__*/function (Orientation) {
  Orientation["Horizontal"] = "horizontal";
  Orientation["Vertical"] = "vertical";
  return Orientation;
}(Orientation || {});
var cssClasses = classNames.bind(styles);
var Divider = function Divider(_ref) {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? Orientation.Horizontal : _ref$orientation,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    testId = _ref.testId,
    className = _ref.className;
  var dividerClass = cssClasses('divider', {
    vertical: orientation === Orientation.Vertical,
    inverse: inverse,
    active: active
  }, className);
  return /*#__PURE__*/jsx("div", {
    className: dividerClass,
    "data-testid": testId
  });
};
Divider.Orientation = Orientation;

export { Divider as default };
//# sourceMappingURL=Divider.js.map
